import { motion, useReducedMotion } from 'framer-motion';
import { transition } from '../lib/motion.js';

export default function Tabs({ tabs, value, onChange }) {
  const reduceMotion = useReducedMotion();

  return (
    <div className="mt-4 flex items-stretch gap-1 border-b border-border">
      {tabs.map((tab) => {
        const active = tab.id === value;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`relative flex min-h-[44px] flex-1 cursor-pointer items-center justify-center px-3 pb-2.5 pt-2 text-xs font-semibold uppercase tracking-wide transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 focus-visible:ring-offset-2 focus-visible:ring-offset-bg ${
              active ? 'text-text' : 'text-text-dim hover:text-text-muted'
            }`}
          >
            <span className="relative font-mono">{tab.label}</span>
            {active && (
              <motion.span
                layoutId="tabs-active"
                className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-accent shadow-[0_0_8px_rgba(59,130,246,0.7)]"
                transition={transition(reduceMotion, 'medium')}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
